import { inject, REQUEST_CONTEXT } from '@angular/core';
import type { CacheSettings } from '@hyundai/shared-lib';

export function setRedirect(reqContext: ReqContext, status: number, url: string) {
    reqContext.redirect = { status, url };
}

// oxlint-disable-next-line complexity
export function setHeader(responseInit: ResponseInit, name: string, value: string) {
    if (responseInit.headers instanceof Headers) {
        responseInit.headers.set(name, value);
    } else if (Array.isArray(responseInit.headers)) {
        responseInit.headers.push([name, value]);
    } else if (responseInit.headers) {
        responseInit.headers[name] = value;
    } else {
        responseInit.headers = { [name]: value };
    }
}

export interface RedirectData {
    status?: number;
    url: string;
}

export interface ReqContext {
    redirect?: RedirectData | null;
    cache: CacheSettings;
    pxWorkerSecret?: string | null;
}

export function provideReqContext(ctx: ReqContext) {
    return ctx; // Don't spread ctx, it will be mutated. redirects won't work otherwise
}

export const injectRequestContext = () => inject(REQUEST_CONTEXT, { optional: true }) as ReqContext;
